(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-configurator-section"] && !Shopify.designMode) return;
  try {
    
console.log('[Configurator] JavaScript block started execution.');

const variantIds = {
  original: {
    "80x190 cm": "54424275386716",
    "80x200 cm": "54424275419484",
    "80x210 cm": "54424275452252",
    "80x220 cm": "54424275485020",
    "90x190 cm": "54424275517788",
    "90x200 cm": "54424275550556",
    "90x210 cm": "54424275583324",
    "90x220 cm": "54424275616092",
    "100x200 cm": "54424275648860",
    "100x210 cm": "54424275681628",
    "100x220 cm": "54424275714396",
    "120x190 cm": "54424275747164",
    "120x200 cm": "54424275779932",
    "140x190 cm": "54424275812700",
    "140x200 cm": "54424275845468",
    "160x190 cm": "54424275878236",
    "160x200 cm": "54424275911004",
    "160x210 cm": "54424275943772",
    "160x220 cm": "54424275976540",
    "180x200 cm": "54424276009308",
    "180x210 cm": "54424276042076",
    "180x220 cm": "54424276074844",
    "200x200 cm": "54424276107612"
  },
  plus: {
    "80x190 cm": "54424274633052",
    "80x200 cm": "54424274665820",
    "80x210 cm": "54424274698588",
    "80x220 cm": "54424274731356",
    "90x190 cm": "54424274764124",
    "90x200 cm": "54424274796892",
    "90x210 cm": "54424274829660",
    "90x220 cm": "54424274862428",
    "100x200 cm": "54424274895196",
    "100x210 cm": "54424274927964",
    "100x220 cm": "54424274960732",
    "120x190 cm": "54424274993500",
    "120x200 cm": "54424275026268",
    "140x190 cm": "54424275059036",
    "140x200 cm": "54424275091804",
    "160x190 cm": "54424275124572",
    "160x200 cm": "54424275157340",
    "160x210 cm": "54424275190108",
    "160x220 cm": "54424275222876",
    "180x200 cm": "54424275255644",
    "180x210 cm": "54424275288412",
    "180x220 cm": "54424275321180",
    "200x200 cm": "54424275353948"
  }
};

let selectedSize = "";
let selectedType = "";
let isSingle = true;
let sleepingOption = "alone";
let userConfig = 3;
let partnerConfig = 3;
let currentFirmness = 3;
let videoIsPlaying = false;
let videoQueue = [];
let previousFirmness = 3;

let productImages = {
  single: "YOUR_STATIC_SINGLE_MATTRESS_IMAGE_URL.jpg",
  double: "YOUR_STATIC_DOUBLE_MATTRESS_IMAGE_URL.jpg"
};

const configDescriptions = {
/*
  1: {{ section.settings.config_1_desc | json }},
  2: {{ section.settings.config_2_desc | json }},
  3: {{ section.settings.config_3_desc | json }},
  4: {{ section.settings.config_4_desc | json }},
  5: {{ section.settings.config_5_desc | json }},
  6: {{ section.settings.config_6_desc | json }}
*/
};

const firmnessVideoUrl = "YOUR_STATIC_FIRMNESS_VIDEO_URL.mp4";

const firmnessMappings = {};
const placeholderVideos = {};
const staticFirmnessVideos = {};

if (firmnessVideoUrl) {
  for (let i = 1; i <= 6; i++) {
    staticFirmnessVideos[i] = firmnessVideoUrl;
    for (let j = 1; j <= 6; j++) {
      if (i !== j) {
        const key = `${i}_${j}`;
        firmnessMappings[key] = firmnessVideoUrl;
        placeholderVideos[key] = firmnessVideoUrl;
      }
    }
  }
}

window.getSelectedVariantDetails = function() {
  const result = { type: "plus", size: "", variantId: "" };
  const mattressTypeSelect = document.querySelector('select[name="options[Mattress Types]"]');
  if (mattressTypeSelect) {
    const selectedValue = mattressTypeSelect.options[mattressTypeSelect.selectedIndex]?.value || "";
    result.type = selectedValue.includes("Plus") ? "plus" : "original";
  } else {
    if (typeof meta !== 'undefined' && meta.product) {
      const selectedVariantId = document.querySelector('input[name="id"]:checked, select[name="id"]')?.value;
      const selectedVariant = meta.product.variants.find(v => v.id.toString() === selectedVariantId);
      if (selectedVariant) {
        result.type = selectedVariant.title.includes("Plus") ? "plus" : "original";
        const sizeMatch = selectedVariant.title.match(/(\d+x\d+\s*cm)/i);
        if (sizeMatch) result.size = sizeMatch[1];
        result.variantId = selectedVariant.id.toString();
      }
    }
    if (!result.variantId) {
      const typeSelectors = document.querySelectorAll('[name="options[Type]"], [name="options[Mattress Type]"], [data-option-name="Type"]');
      for (const selector of typeSelectors) {
        if (selector.tagName === 'SELECT') {
          const selected = selector.options[selector.selectedIndex]?.value || "";
          result.type = selected.includes("Plus") ? "plus" : "original"; break;
        } else if (selector.checked) {
          result.type = selector.value.includes("Plus") ? "plus" : "original"; break;
        }
      }
    }
  }
  const sizeSelectors = document.querySelectorAll('[name="options[Size]"], [data-option-name="Size"], select:not([name="id"]):not([name="options[Mattress Types]"])');
  for (const selector of sizeSelectors) {
    if (selector.tagName === 'SELECT') {
      const selectedOption = selector.options[selector.selectedIndex];
      if (selectedOption) {
        const value = selectedOption.value || selectedOption.textContent;
        if (value && /\d+x\d+/.test(value)) { result.size = value; break; }
      }
    } else if (selector.checked) {
      const value = selector.value;
      if (value && /\d+x\d+/.test(value)) { result.size = value; break; }
    }
  }
  if (result.type && result.size && variantIds[result.type]?.[result.size]) {
    result.variantId = variantIds[result.type][result.size];
  }
  if (!result.variantId) {
    const variantIdField = document.querySelector('input[name="id"]:checked, select[name="id"]');
    if (variantIdField) {
      result.variantId = variantIdField.value;
      for (const type in variantIds) {
        for (const size in variantIds[type]) {
          if (variantIds[type][size] === result.variantId) {
            result.type = type; result.size = size; break;
          }
        }
      }
    }
  }
  if (result.size) {
    if (!result.size.includes(" cm") && /\d+x\d+/.test(result.size)) { result.size += " cm"; }
    result.size = result.size.trim();
  }
  return result;
}

window.getProductImagesFromPage = function() {
  return { single: productImages.single, double: productImages.double };
}

window.openConfigurator = function() {
  console.log('[Configurator] openConfigurator called');
  try {
    const variantDetails = getSelectedVariantDetails();
    console.log('[Configurator] variantDetails:', variantDetails);
    selectedType = variantDetails.type || "plus";
    if (variantDetails.size) selectedSize = variantDetails.size;

    productImages = getProductImagesFromPage();
    console.log('[Configurator] productImages:', productImages);
    preloadImages();

    const modal = document.getElementById("configuratorModal");
    console.log('[Configurator] Modal element:', modal);
    if (!modal) {
      console.error('[Configurator] CRITICAL: Modal element not found!');
      return;
    }

    modal.style.display = "flex";
    console.log('[Configurator] Modal display style set to flex. Current display:', window.getComputedStyle(modal).display);

    void modal.offsetWidth;

    modal.classList.add("active");
    console.log('[Configurator] "active" class added. Classes:', modal.className);
    console.log('[Configurator] Modal transform style:', window.getComputedStyle(modal).transform);

    if (selectedSize) {
      isSingle = (parseInt(selectedSize.split("x")[0], 10) || 0) <= 120;
    }
    console.log('[Configurator] isSingle:', isSingle);

    updateMattressImage();
    console.log('[Configurator] updateMattressImage called');

    initializeConfigurator();
    console.log('[Configurator] initializeConfigurator called');

    showStep(1);
    console.log('[Configurator] showStep(1) called');
  } catch (error) {
    console.error('[Configurator] Error in openConfigurator:', error);
  }
}

window.closeConfigurator = function() {
  const modal = document.getElementById("configuratorModal");
  modal.classList.remove("active");
  modal.classList.add("closing");
  setTimeout(() => { modal.classList.remove("closing"); modal.style.display = "none"; }, 500);
}

window.showStep = function(step) {
  document.querySelectorAll(".configurator-step").forEach(div => div.classList.remove("active"));
  const stepId = (typeof step === 'number') ? "step" + step : step;
  document.getElementById(stepId)?.classList.add("active");
  if (typeof step === 'number' && step === 1) { toggleSizeType(isSingle ? 'single' : 'double'); }

  const rightPanel = document.querySelector('.configurator-right');
  rightPanel.querySelectorAll('.firmness-levels').forEach(el => el.remove());

  const currentStepId = (typeof step === 'number') ? 'step' + step : step;
  if (currentStepId === 'step2a' || currentStepId === '2') { addFirmnessLevels('firmness-levels-single', 'left-side', userConfig); }
  else if (currentStepId === 'step3a') { addFirmnessLevels('firmness-levels-alone', 'left-side', userConfig); }
  else if (currentStepId === 'step3b') { addFirmnessLevels('firmness-levels-you', 'left-side', userConfig); addFirmnessLevels('firmness-levels-partner', 'right-side', partnerConfig); }
  updateMattressImage();
}

window.toggleSizeType = function(type) {
  document.querySelectorAll('.size-option').forEach(option => option.classList.remove('active'));
  const selector = (type === 'single') ? '.size-option:first-child' : '.size-option:last-child';
  document.querySelector(selector)?.classList.add('active');
  isSingle = (type === 'single');

  const currentVariantType = selectedType || 'plus'; // Ensure selectedType is defined
  const sizes = Object.keys(variantIds[currentVariantType] || {});
  const filtered = sizes.filter(size => (isSingle ? parseInt(size.split("x")[0]) <= 120 : parseInt(size.split("x")[0]) > 120));
  const container = document.getElementById("sizeOptions");
  if (container) {
      container.innerHTML = filtered.map(size => `
      <div onclick="selectSizeOption('${size.replace(/'/g, "\\'")}')">
        <input type="radio" name="configSize" value="${size}" id="${size.replace(/\s+/g, '')}" ${selectedSize === size ? 'checked' : ''}>
        <label for="${size.replace(/\s+/g, '')}">${size}</label>
      </div>`).join("");
  }
  updateMattressImage();
}

window.selectSizeOption = function(size) {
  selectedSize = size;
  const radio = document.querySelector(`input[name='configSize'][value="${size}"]`);
  if (radio) radio.checked = true;
  const sizeWidth = parseInt(size.split("x")[0]) || 0;
  const newIsSingle = sizeWidth <= 120;
  if (newIsSingle !== isSingle) {
    isSingle = newIsSingle;
    document.querySelectorAll('.size-option').forEach(option => option.classList.remove('active'));
    const selector = isSingle ? '.size-option:first-child' : '.size-option:last-child';
    document.querySelector(selector)?.classList.add('active');
    updateMattressImage();
  }
}

window.updateMattressImage = function() {
  const imageElement = document.getElementById('mattressImage');
  const videoElement = document.getElementById('mattressVideo');
  if (videoElement) videoElement.style.display = 'none';
  if (imageElement) {
    imageElement.style.display = 'block';
    imageElement.src = isSingle ? productImages.single : productImages.double;
  }
}

window.updateSliderValue = function(elementId, value) {
  const el = document.getElementById(elementId);
  if (el) el.textContent = value;
}

window.updateFirmness = function(value) { _updateFirmness(value, 'firmness-levels-single'); }
window.updateFirmnessAlone = function(value) { _updateFirmness(value, 'firmness-levels-alone'); }
window.updateFirmnessYou = function(value) { _updateFirmness(value, 'firmness-levels-you'); }

function _updateFirmness(value, levelId) {
  if (videoIsPlaying) return;
  const newFirmness = parseInt(value);
  if (newFirmness === currentFirmness) return;
  const fromLevel = currentFirmness;
  const toLevel = newFirmness;
  userConfig = toLevel;
  updateFirmnessHighlight(levelId, userConfig);
  playFirmnessTransitionVideo(fromLevel, toLevel);
  currentFirmness = toLevel;
}

window.updateFirmnessPartner = function(value) {
  if (videoIsPlaying) return;
  const newFirmness = parseInt(value);
  if (newFirmness === partnerConfig) return;
  partnerConfig = newFirmness;
  updateFirmnessHighlight('firmness-levels-partner', partnerConfig);
}

window.playFirmnessTransitionVideo = function(fromLevel, toLevel) {
  const video = document.getElementById('mattressVideo');
  const videoSource = document.getElementById('videoSource');
  const image = document.getElementById('mattressImage');
  if (!video || !videoSource || !image) return;

  const mappingKey = `${fromLevel}_${toLevel}`;
  let videoUrl = firmnessMappings[mappingKey] || placeholderVideos[mappingKey] || staticFirmnessVideos[toLevel];

  const switchToImage = () => {
    if (video) { video.pause(); video.style.display = 'none'; }
    if (image) image.style.display = 'block';
    setFirmnessControlsEnabled(true);
    videoIsPlaying = false;
  };

  if (videoUrl) {
    setFirmnessControlsEnabled(false);
    image.style.display = 'none';
    try {
      videoSource.src = videoUrl;
      video.load();
      video.style.display = 'block';
      video.style.zIndex = '2';
      image.style.zIndex = '1';
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(() => { videoIsPlaying = true; })
        .catch(error => { console.error('Video playback failed:', error); switchToImage(); });
      } else { videoIsPlaying = true; }
      video.onended = () => { videoIsPlaying = false; setFirmnessControlsEnabled(true); switchToImage(); };
      video.onerror = (e) => { console.error('Video error event:', e); switchToImage(); };
    } catch (err) { console.error('Error setting up video:', err); switchToImage(); }
  } else { switchToImage(); }
}

window.updateFirmnessHighlight = function(containerId, level) {
  const container = document.getElementById(containerId);
  if (container) {
    container.querySelectorAll('.firmness-level').forEach((item, index) => {
      item.classList.toggle('active', index + 1 === level);
    });
  }
}

window.confirmSize = function() {
  const selected = document.querySelector("input[name='configSize']:checked");
  if (selected) { selectedSize = selected.value; showStep(isSingle ? "step2a" : "step2b"); }
  else { alert("Please select a size."); }
}

window.selectSleepingOption = function(option) {
  document.querySelectorAll(".configurator-tab").forEach(t => t.classList.remove("active"));
  event.target.classList.add("active");
  sleepingOption = option;
}

window.confirmSleepingOption = function() { showStep(sleepingOption === "alone" ? "step3a" : "step3b"); }

window.showResult = function() {
  let resultHTML = "";
  const configImgBaseUrl = "https://cdn.shopify.com/s/files/1/0906/0286/4988/files/Configuration_";
  const configImgSuffix = ".png?v=1746252483";
  const commonText = "<p>Thanks to the hypersupport you get the right pressure wherever you need it. The memory foam is formed to your body and relieves the pressure points. When you take Nørd out of the box, he will be ready for you to use immediately.</p>";
  const imgStyle = "style=\"width: 100%; max-width: 600px; margin-top: 20px;\"";

  if (isSingle || sleepingOption === "alone") {
    resultHTML = `<h3>Your result: configuration ${userConfig}</h3><p>${configDescriptions[userConfig]}</p>${commonText}<img src="${configImgBaseUrl}${userConfig}${configImgSuffix}" alt="Configuration ${userConfig}" ${imgStyle}>`;
  } else {
    resultHTML = `<p>You probably knew this already but the two of you form a dream couple. Order a double Nørd now, adjust the layers to your personal preferences and snuggle together without a split in the middle of the bed.</p>
                  <h3>Your result: configuration ${userConfig}</h3><p>${configDescriptions[userConfig]}</p><img src="${configImgBaseUrl}${userConfig}${configImgSuffix}" alt="Configuration ${userConfig}" ${imgStyle}>
                  <h3>Result of your partner: configuration ${partnerConfig}</h3><p>${configDescriptions[partnerConfig]}</p><img src="${configImgBaseUrl}${partnerConfig}${configImgSuffix}" alt="Configuration ${partnerConfig}" ${imgStyle}>
                  ${commonText.replace("he will be ready for you", "it will be ready for you both")}`;
  }
  const resultTextEl = document.getElementById("resultText");
  if (resultTextEl) resultTextEl.innerHTML = resultHTML;
  showStep(4);
}

window.addToCart = function() {
  const variantDetails = getSelectedVariantDetails();
  const sizeToUse = selectedSize || variantDetails.size;
  if (!sizeToUse || !variantDetails.type || !variantIds[variantDetails.type]?.[sizeToUse]) {
    alert("Could not determine the correct product variant. Please try again or select a different size."); return;
  }
  const variantId = variantIds[variantDetails.type][sizeToUse];
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: { 'Configuration': userConfig, 'Partner Configuration': (isSingle || sleepingOption === "alone") ? null : partnerConfig }
    })
  }).then(response => {
    if (response.ok) { window.location.href = '/cart'; }
    else { response.json().then(data => alert("Error adding to cart: " + (data.description || response.statusText))); }
  }).catch(error => { console.error("Error:", error); alert("There was an error adding to cart. Please try again."); });
}

window.addFirmnessLevels = function(id, position, activeLevel) {
  const rightPanel = document.querySelector('.configurator-right');
  if (!rightPanel) return;
  const firmnessLevels = document.createElement('div');
  firmnessLevels.className = `firmness-levels ${position}`;
  firmnessLevels.id = id;
  const labels = ['Extra soft', 'Soft', 'Medium', 'Medium/firm', 'Firm', 'Extra firm'];
  for (let i = 1; i <= 6; i++) {
    const level = document.createElement('div');
    level.className = `firmness-level ${i === activeLevel ? 'active' : ''}`;
    const dot = document.createElement('div'); dot.className = 'firmness-level-dot';
    const text = document.createElement('span'); text.textContent = `${i} ${labels[i-1] || ''}`;
    level.append(dot, text);
    firmnessLevels.appendChild(level);
  }
  rightPanel.appendChild(firmnessLevels);
}

window.setupVariantListeners = function() {
    const variantSelectors = document.querySelectorAll('select[data-index], input[name^="options"]');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', () => {
        const modal = document.getElementById("configuratorModal");
        if (modal && modal.classList.contains("active")) {
          const variantDetails = getSelectedVariantDetails();
          selectedType = variantDetails.type;
        }
      });
    });
}

window.preloadImages = function() {
  if (productImages.single) new Image().src = productImages.single;
  if (productImages.double) new Image().src = productImages.double;
}

window.setFirmnessControlsEnabled = function(enabled) {
  const firmnessSliders = ['firmness', 'firmnessAlone', 'firmnessYou', 'firmnessPartner'];
  firmnessSliders.forEach(id => {
    const slider = document.getElementById(id);
    if (slider) {
      slider.disabled = !enabled;
      slider.style.opacity = enabled ? '1' : '0.6';
      slider.style.cursor = enabled ? 'pointer' : 'not-allowed';
    }
  });
}

window.initializeConfigurator = function() {
  const fields = {
    'weight': 75, 'weightValue': 75, 'firmness': 3,
    'weightAlone': 75, 'weightValueAlone': 75, 'firmnessAlone': 3,
    'weightYou': 75, 'weightValueYou': 75, 'firmnessYou': 3,
    'weightPartner': 75, 'weightValuePartner': 75, 'firmnessPartner': 3
  };
  for (const id in fields) {
    const el = document.getElementById(id);
    if (el) {
      if (id.includes('Value')) { el.textContent = fields[id]; }
      else { el.value = fields[id]; }
    }
  }
  userConfig = 3; partnerConfig = 3; currentFirmness = 3;
  preloadImages();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setupVariantListeners();
        initializeConfigurator();
    });
} else {
    setupVariantListeners();
    initializeConfigurator();
}

console.log('[Configurator] typeof openConfigurator at end of script:', typeof window.openConfigurator);

  } catch(e) { console.error(e); }
})();
})();
